import React from 'react';
import {FaAngleLeft, FaAngleRight} from "react-icons/fa6";

const CollapseButton = ({ buttonRef, toggleFilters, fixedTop, collapsed, appShellCollapsed, menuWidth }) => {
    const collapsedLeft = appShellCollapsed ? "2px" : "222px";

    return (
        <button
            ref={buttonRef}
            id="collapse-filters"
            onClick={toggleFilters}
            className="z-20 bg-white border border-gray-300 rounded-md w-6 h-20 flex items-center justify-center shadow hover:bg-gray-100 cursor-pointer"
            style={{
                left: collapsed ? collapsedLeft : `${menuWidth}px`,
                top: collapsed ? `${fixedTop ?? 78}px` : "42px",
                position: collapsed ? "fixed" : "relative",
                opacity: collapsed ? 0.5 : 1,
                transition: "opacity 0.2s ease",
            }}
        >

            { collapsed ? <FaAngleRight/> : <FaAngleLeft/> }

        </button>
    );
};

export default CollapseButton;